export default "__VITE_ASSET__CgRWwEXH__"